/**
 * Fondos por defecto (gradientes) cuando el ítem no define `avatarClassName`.
 * Sirve para agentes, workspaces, equipos, etc.
 */
export const SEARCHABLE_SELECT_AVATAR_PRESETS = [
  'bg-gradient-to-br from-blue-600 to-purple-600',
  'bg-gradient-to-br from-green-600 to-emerald-600',
  'bg-gradient-to-br from-orange-600 to-red-600',
  'bg-gradient-to-br from-pink-600 to-purple-600',
  'bg-gradient-to-br from-cyan-600 to-blue-600',
  'bg-gradient-to-br from-violet-600 to-indigo-600',
];

/**
 * @param {{ avatarClassName?: string }} option
 * @param {number} index
 * @returns {string}
 */
export function resolveOptionAvatarClassName(option, index) {
  if (option.avatarClassName?.trim()) return option.avatarClassName.trim();
  return SEARCHABLE_SELECT_AVATAR_PRESETS[index % SEARCHABLE_SELECT_AVATAR_PRESETS.length];
}

/**
 * Iniciales cortas (hasta 2 caracteres): `initial` explícito, o iniciales por palabras / nombre.
 * @param {{ initial?: string, name?: string }} option
 * @returns {string}
 */
export function resolveOptionLabelText(option) {
  if (option.initial != null && String(option.initial).trim() !== '') {
    return String(option.initial).trim().slice(0, 2).toUpperCase();
  }
  const name = (option.name ?? '').trim();
  if (!name) return '?';
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const a = parts[0][0] ?? '';
    const b = parts[1][0] ?? '';
    return `${a}${b}`.toUpperCase().slice(0, 2);
  }
  return name.slice(0, 2).toUpperCase();
}

/**
 * @param {Array<{ name?: string, subtitle?: string }>} items
 * @param {string} query
 */
export function filterOptionsByQuery(items, query) {
  const t = query.trim().toLowerCase();
  if (!t) return items;
  return items.filter((item) => {
    const name = (item.name ?? '').toLowerCase();
    const sub = (item.subtitle ?? '').toLowerCase();
    return name.includes(t) || sub.includes(t);
  });
}
